module.exports = __webpack_public_path__ + "img/nav-bar.0f8c5da0.png";